module.exports = __webpack_public_path__ + "img/s5.png";